<template>
  <div>
    <div class="row mt-2">
      <div class="col-12 ps-0">
        <div class="col-12 mt-3 mb-2"
             style="font-weight: bold;
             font-size: 18px;
             border-bottom: 1px solid #ddd;">
          {{ title }}
        </div>
      </div>

      <!-- Loop through items and render inputs -->
      <div class="col-12" v-for="(item, index) in items" :key="index">
        <div class="row mt-5">
          <BaseInput v-model="item.id"
                     hidden="hidden"/>

          <!-- Title input or select -->
          <div class="col-lg-2 col-md-4 col-sm-12">
            <SelectVue
                v-model="item.year"
                :options="yearsDropdown"
                :label="itemYearLabel"
                :is-clear="true"
                :placeholder="itemSelectPlaceholder"/>
          </div>

          <div class="col-lg-10 col-md-8 col-sm-12">
            <TextEditor
                v-model="item.description"
                @update:model-value="item.description = $event"
                :inputStyle="{ height: '200px' }"
                :label="itemDescriptionLabel"/>
          </div>
        </div>

        <!-- Delete Button -->
        <button
            class="btn btn-danger mt-2"
            v-if="items && items.length > 0"
            @click="deleteItem(index)">
          Löschen
        </button>
      </div>
    </div>

    <!-- Add Button -->
    <div class="text-end mb-5">
      <button type="button" class="btn btn-primary" @click="addItem">
        +
      </button>
    </div>
  </div>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import { computed, defineEmits, defineProps } from 'vue';

// Props
defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  itemYearLabel: {
    type: String,
    default: '',
  },
  itemDescriptionLabel: {
    type: String,
    default: '',
  },
  itemSelectPlaceholder: {
    type: String,
    required: false,
    default: 'Wert auswählen',
  },
  dropdownOptions: {
    type: Array,
    default: () => [],
  },
});

const currentYear = new Date().getFullYear();
const startYear = 1984;

// Computed property to generate the year range
const yearsDropdown = computed(() => {
  const yearsArray = [];
  for (let year = currentYear; year >= startYear; year--) {
    yearsArray.push({
      label: year.toString(), // Label for dropdown
      value: year.toString(),            // Value for selection
    });
  }
  return yearsArray;
});

// Emits
const emit = defineEmits([ 'addItem', 'deleteItem' ]);

// Helper Methods
const addItem    = () => {
  emit('addItem', { year: '', description: '' });
};
const deleteItem = (index) => {
  emit('deleteItem', index);
};
</script>

<style scoped>
/* Add component-specific styles here if necessary */
</style>
